import { DataTable } from '@/components'
import { useHeaderAdmin } from '@/hooks'
import { AddCircleOutlineOutlined } from '@mui/icons-material'
import { Alert, Button } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { useEffectOnce } from 'react-use'
import { TABLE_COLUMNS } from './table-columns'
import { TableToolbar } from './table-toolbar'

import services from '@/services'
import ModalRegisterAndUpdate from './modal-register-and-update'

export default function Documents() {
  const { setTitle, setAction } = useHeaderAdmin()
  const [isOpen, setIsOpen] = useState(false)
  const { data, isLoading, error } = useQuery({
    queryKey: ['/documents'],
    queryFn: services.attachments.getAttachments,
  })

  useEffectOnce(() => setTitle('Ligações e Documentos'))
  useEffectOnce(() => {
    setAction(
      <Button onClick={() => setIsOpen(true)}>
        <AddCircleOutlineOutlined />
        <span>criar</span>
      </Button>,
    )
  })

  function onClose() {
    setIsOpen(false)
  }

  return (
    <>
      {error && (
        <Alert severity="error" className="mb-5">
          {(error as Error).message}
        </Alert>
      )}
      {isOpen && <ModalRegisterAndUpdate onClose={onClose} open={isOpen} />}

      <DataTable
        data={data || []}
        isLoading={isLoading}
        columns={TABLE_COLUMNS}
        inputProps={{ name: 'label' }}
        toolbar={(table) => <TableToolbar table={table} />}
        actions={{
          queryKey: ['/documents'],
          async onDelete(data) {
            await services.attachments.deleteById(data.id)
          },
        }}
      />
    </>
  )
}
